var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Watch, Prop, Emit } from "vue-property-decorator";
import { State } from "vuex-class";
import { Dependencies } from "~/core/decorator";
import { NetService } from "~/utils/net.service";
import { commonService } from "~/config/server";
import app from "~/config/app.config";
import { StorageService } from "~/utils/storage.service";
import { FileUploadService } from "~/services/file-service/file-upload.service";
import { CaseOutContrastController } from "~/services/domain-service/case-out-contrast.service";
import { CaseOutRecordController } from "~/services/domain-service/case-out-record.service";
import { SystemToolsService } from "~/services/domain-service/system-tools.service";
var FileUpload = /** @class */ (function (_super) {
    __extends(FileUpload, _super);
    function FileUpload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dialogImageUrl = "";
        _this.dialogVisible = false;
        _this.urlFileList = [];
        return _this;
    }
    // 上传成功回调事件
    FileUpload.prototype.onUploadSucess = function (id, data) {
        this.updateFileList(data);
    };
    // 上传进度回调事件
    FileUpload.prototype.onUploadProgress = function (id, percent) { };
    // 上传异常回调事件
    FileUpload.prototype.onUploadError = function (id, error) { };
    // 更新文件列表
    FileUpload.prototype.updateFileList = function (fileList) { };
    //删除成功的回调事件
    FileUpload.prototype.onUploadRemove = function (file, fileList) { };
    // 上传文件回显
    FileUpload.prototype.recordFildIdChange = function (val) {
        var _this = this;
        var fileList = [];
        if (val) {
            val.split(",").map(function (val) {
                if (val) {
                    _this.FileUpload.getUploadFile(val).subscribe(function (data) {
                        var temp = __assign({}, data);
                        temp.name = data.originalName;
                        temp.response = {};
                        temp.response.id = data.id;
                        fileList.push(temp);
                    });
                }
            });
        }
        this.updateFileList(fileList);
    };
    Object.defineProperty(FileUpload.prototype, "headers", {
        // 获取上传文件头部信息
        get: function () {
            var token = StorageService.getItem("userToken") || "";
            return {
                "X-UserToken": token,
            };
            // return {
            //   "X-UserToken": this.userToken
            // };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FileUpload.prototype, "disableUpload", {
        /**
         * 是否禁止上传
         */
        get: function () {
            return this.fileNumberLimit
                ? this.fileList.length >= this.fileNumberLimit
                : false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FileUpload.prototype, "uploadUrl", {
        /**
         * 上传路径
         */
        get: function () {
            return [
                app.url.server,
                NetService.generateRequestUrl(commonService.uploadFileController.upload),
            ].join("/");
        },
        enumerable: false,
        configurable: true
    });
    FileUpload.prototype.clickHandle = function (event) {
        if (this.disableUpload) {
            event.preventDefault();
            event.stopPropagation();
        }
    };
    /**
     * 上传成功回调
     */
    FileUpload.prototype.onSucess = function (data, _a) {
        var uid = _a.uid;
        data.createTime = new Date().getTime();
        this.onUploadSucess(uid, data);
    };
    /**
     * 上传进度回调
     */
    FileUpload.prototype.onProgress = function (_a, _b) {
        var percent = _a.percent;
        var uid = _b.uid;
    };
    /**
     * 错误信息回调
     */
    FileUpload.prototype.onError = function (err, file) {
        this.onUploadError(err, file);
    };
    /**
     * 文件上传状态改变回调
     */
    FileUpload.prototype.onChange = function (file, uploadFileList) {
        switch (file.status) {
            case "ready": {
                this.fileList.push({
                    uid: file.uid,
                    name: file.name,
                    percentage: file.percentage,
                    status: file.status,
                    url: file.url,
                });
                break;
            }
        }
        this.updateFileList(this.fileList);
    };
    /**
     * 删除处理
     */
    FileUpload.prototype.onRemove = function (file, fileList) {
        this.onUploadRemove(file, fileList);
        this.updateFileList(fileList);
        this.deleteInterface(file, fileList);
    };
    FileUpload.prototype.deleteInterface = function (file, fileList) {
        var _this = this;
        if (!file.response && !file.response.id)
            return;
        this.FileUpload.deleteById(file.response.id).subscribe(function (data) {
            _this.$message.success("删除成功！");
        });
    };
    /**
     * 删除预处理
     */
    FileUpload.prototype.onBeforeRemove = function (file, fileList) {
        var _this = this;
        if (file.percentage === 0) {
            var list = fileList.filter(function (x) { return x.uid !== file.uid; });
            this.updateFileList(list);
            return false;
        }
        return this.$confirm("是否确定删除该文件?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
        }).then(function () {
            _this.$emit("close");
        });
    };
    /**
     * 上传文件预处理
     * 上传文件大小限制
     */
    FileUpload.prototype.onBeforeUpload = function (_a) {
        var name = _a.name, size = _a.size, uid = _a.uid, type = _a.type;
        if (this.AllowExtension && this.AllowExtension.length) {
            // 文件名异常
            if (name.toString().split(".").length < 2) {
                this.$message("\u6587\u4EF6\u683C\u5F0F\u9519\u8BEF");
                return false;
            }
            // const [extension] = name.split(".").slice(-1);
            // if (!this.AllowExtension.includes(extension)) {
            var extension = name.split(".").pop().toLowerCase();
            if (!this.AllowExtension.map(function (x) { return x.toLowerCase(); }).includes(extension)) {
                this.$message("\u6587\u4EF6\u683C\u5F0F\u4E0D\u7B26\u5408\u8981\u6C42");
                return false;
            }
        }
        // 限制上传文件大小
        if (this.fileSizeLimit * 1024 * 1024 < size) {
            this.$message("\u6587\u4EF6" + name + "\u8D85\u8FC7\u4E0A\u4F20\u6587\u4EF6\u5927\u5C0F\u9650\u5236" + this.fileSizeLimit + "MB");
            return false;
        }
    };
    FileUpload.prototype.handleExceed = function (files, fileList) {
        if (this.fileNumberLimit) {
            this.$message.warning("\u5F53\u524D\u9650\u5236\u9009\u62E9" + this.fileNumberLimit + "\u4E2A\u6587\u4EF6\uFF0C\u672C\u6B21\u9009\u62E9\u4E86 " + files.length + " \u4E2A\u6587\u4EF6\uFF0C\u5171\u9009\u62E9\u4E86 " + (files.length + fileList.length) + " \u4E2A\u6587\u4EF6");
        }
    };
    FileUpload.prototype.reset = function () {
        var upload = this.$refs["upload"];
        upload.clearFiles();
        this.updateFileList([]);
    };
    /**
     * 下载模板
     */
    FileUpload.prototype.downloadMoClick = function () {
        var _this = this;
        if (this.showSM === 1) {
            this.caseOutContrastController.downLoadBill().subscribe(function (data) {
                _this.$common.downloadFile(data);
            });
        }
        if (this.showSM === 2) {
            this.caseOutContrastController
                .downLoadRepaymentRecord()
                .subscribe(function (data) {
                _this.$common.downloadFile(data);
            });
        }
        if (this.showSM === 3) {
            this.caseOutRecordController.downLoadMobileUrge().subscribe(function (data) {
                _this.$common.downloadFile(data);
            });
        }
        if (this.showSM === 4) {
            this.caseOutRecordController.downLoadOutVisit().subscribe(function (data) {
                _this.$common.downloadFile(data);
            });
        }
        if (this.showSM === 5) {
            this.systemToolsService.downLoadRiskInfoTemplate().subscribe(function (data) {
                _this.$common.downloadFile(data);
            });
        }
    };
    /**
     * 照片墙图片显示
     */
    FileUpload.prototype.handlePictureCardPreview = function (file) {
        this.dialogImageUrl = file.response.url;
        this.dialogVisible = true;
        console.log(this.fileList);
        this.urlFileList = this.fileList.map(function (v) { return v.response.url; });
        console.log(this.urlFileList);
    };
    __decorate([
        Dependencies(FileUploadService)
    ], FileUpload.prototype, "FileUpload", void 0);
    __decorate([
        Dependencies(CaseOutContrastController)
    ], FileUpload.prototype, "caseOutContrastController", void 0);
    __decorate([
        Dependencies(CaseOutRecordController)
    ], FileUpload.prototype, "caseOutRecordController", void 0);
    __decorate([
        Dependencies(SystemToolsService)
    ], FileUpload.prototype, "systemToolsService", void 0);
    __decorate([
        State
    ], FileUpload.prototype, "userToken", void 0);
    __decorate([
        Prop({ default: true })
    ], FileUpload.prototype, "showFileList", void 0);
    __decorate([
        Prop()
    ], FileUpload.prototype, "disabled", void 0);
    __decorate([
        Prop({
            type: Array,
        })
    ], FileUpload.prototype, "AllowExtension", void 0);
    __decorate([
        Prop({
            type: Number,
        })
    ], FileUpload.prototype, "showSM", void 0);
    __decorate([
        Prop({ default: "text" })
    ], FileUpload.prototype, "listType", void 0);
    __decorate([
        Prop({
            type: String,
        })
    ], FileUpload.prototype, "recordFildId", void 0);
    __decorate([
        Prop({
            type: String,
        })
    ], FileUpload.prototype, "accept", void 0);
    __decorate([
        Prop({ default: "上传文件" })
    ], FileUpload.prototype, "buttonName", void 0);
    __decorate([
        Prop({ default: "primary" })
    ], FileUpload.prototype, "buttonType", void 0);
    __decorate([
        Prop({
            default: false,
            type: [Boolean, Number],
        })
    ], FileUpload.prototype, "fileNumberLimit", void 0);
    __decorate([
        Prop({
            default: 500,
            type: Number,
        })
    ], FileUpload.prototype, "fileSizeLimit", void 0);
    __decorate([
        Prop({
            default: function () { return []; },
            type: Array,
        })
    ], FileUpload.prototype, "fileList", void 0);
    __decorate([
        Emit("onUploadSuccess")
    ], FileUpload.prototype, "onUploadSucess", null);
    __decorate([
        Emit("onUploadProgress")
    ], FileUpload.prototype, "onUploadProgress", null);
    __decorate([
        Emit("onUploadError")
    ], FileUpload.prototype, "onUploadError", null);
    __decorate([
        Emit("update:fileList")
    ], FileUpload.prototype, "updateFileList", null);
    __decorate([
        Emit("onUploadRemove")
    ], FileUpload.prototype, "onUploadRemove", null);
    __decorate([
        Watch("recordFildId")
    ], FileUpload.prototype, "recordFildIdChange", null);
    FileUpload = __decorate([
        Component({
            components: {},
        })
    ], FileUpload);
    return FileUpload;
}(Vue));
export default FileUpload;
